import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import Header from '../components/Header';
import Footer from '../components/Footer';
import MobileMenu from '../components/MobileMenu';
import PopupSearch from '../components/PopupSearch';
import ScrollToTop from '../components/ScrollToTop';

const Cart: React.FC = () => {
  const [openForm, setOpenForm] = useState(false);
   const [menuOpen, setMenuOpen] =  useState(false);
  const [cartItems, setCartItems] = useState([
    {
      id: 1,
      name: 'Gold Ring Set',
      price: 200,
      quantity: 1,
      image: '/assets/img/products5/product-1-1.png',
    },
  ]);

  const increaseQty = (id: number) => {
    setCartItems(
      cartItems.map((item) =>
        item.id === id
          ? { ...item, quantity: item.quantity + 1 }
          : item
      )
    );
  };

  const decreaseQty = (id: number) => {
    setCartItems(
      cartItems.map((item) =>
        item.id === id && item.quantity > 1
          ? { ...item, quantity: item.quantity - 1 }
          : item
      )
    );
  };

  const removeItem = (id: number) => {
    setCartItems(cartItems.filter((item) => item.id !== id));
  };

  const subtotal = cartItems.reduce(
    (acc, item) => acc + item.price * item.quantity,
    0
  );

  const shipping = 0;

  const total = subtotal + shipping;

  return (
    <>
      <MobileMenu
  isOpen={menuOpen}
  onClose={() => setMenuOpen(false)}
/>
      <PopupSearch />

      <main className="main">

        <Header />

        {/* Breadcumb */}
        <div
          className="breadcumb-wrapper"
          style={{
            backgroundImage:
              "url('/assets/img/bg/breadcumb-bg-4.jpg')",
                   backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
          }}
        >
          <img
            src="/assets/img/shapes/dot-shape.svg"
            alt="dot"
            className="breadcumb-element"
          />

          <div className="container z-index-common">
            <div className="breadcumb-content">

              <h1 className="breadcumb-title">
                Cart
              </h1>

              <div className="breadcumb-menu-wrap">
                <ul className="breadcumb-menu">

                  <li>
                    <Link to="/">Home</Link>
                  </li>

                  <li>Cart</li>

                </ul>
              </div>

            </div>
          </div>
        </div>

        {/* Cart Area */}
        <section className="space shop-page1 space-extra-bottom">

          <div className="container">

            <div className="woocommerce-notices-wrapper">
              <div className="woocommerce-message">
                Shipping costs updated.
              </div>
            </div>

            {/* Cart Table */}
            <form className="woocommerce-cart-form">

              <table className="cart_table">

                <thead>
                  <tr>
                    <th className="cart-col-image">Image</th>
                    <th className="cart-col-productname">Product Name</th>
                    <th className="cart-col-price">Price</th>
                    <th className="cart-col-quantity">Quantity</th>
                    <th className="cart-col-total">Total</th>
                    <th className="cart-col-remove">Remove</th>
                  </tr>
                </thead>

                <tbody>

                  {cartItems.map((item) => (
                    <tr className="cart_item" key={item.id}>

                      {/* Product Image */}
                      <td data-title="Product">
                        <Link
                          className="cart-productimage"
                          to="/shop"
                        >
                          <img
                            width="100"
                            height="95"
                            src={item.image}
                            alt={item.name}
                          />
                        </Link>
                      </td>

                      {/* Product Name */}
                      <td data-title="Name">
                        <Link
                          className="cart-productname"
                          to="/shop"
                        >
                          {item.name}
                        </Link>
                      </td>

                      {/* Price */}
                      <td data-title="Price">
                        <span className="amount">
                          <bdi>
                            <span>₹</span>
                            {item.price.toFixed(2)}
                          </bdi>
                        </span>
                      </td>

                      {/* Quantity */}
                      <td data-title="Quantity">

                        <div className="quantity style2">

                          <div className="quantity__field quantity-container">

                            <button
                              type="button"
                              className="quantity-minus qty-btn"
                              onClick={() => decreaseQty(item.id)}
                            >
                              <i className="fal fa-minus"></i>
                            </button>

                            <input
                              type="number"
                              className="qty-input"
                              value={item.quantity}
                              readOnly
                            />

                            <button
                              type="button"
                              className="quantity-plus qty-btn"
                              onClick={() => increaseQty(item.id)}
                            >
                              <i className="fal fa-plus"></i>
                            </button>

                          </div>

                        </div>

                      </td>

                      {/* Total */}
                      <td data-title="Total">

                        <span className="amount">
                          <bdi>
                            <span>₹</span>
                            {(item.price * item.quantity).toFixed(2)}
                          </bdi>
                        </span>

                      </td>

                      {/* Remove */}
                      <td data-title="Remove">

                        <button
                          type="button"
                          className="remove"
                          onClick={() => removeItem(item.id)}
                          style={{
                            border: 'none',
                            background: 'transparent',
                          }}
                        >
                          <i className="fal fa-trash-alt"></i>
                        </button>

                      </td>

                    </tr>
                  ))}

                  {/* Cart Actions */}
                  <tr>

                    <td colSpan={6} className="cart-actions">

                      <div className="row justify-content-between">

                        {/* Coupon */}
                        <div className="col-lg-6">

                          <div className="vs-cart-coupon">

                            <input
                              type="text"
                              className="form-control"
                              placeholder="Coupon Code..."
                            />

                            <button
                              type="button"
                              className="vs-btn"
                            >
                              Apply Coupon
                            </button>

                          </div>

                        </div>

                        {/* Buttons */}
                        <div className="col-lg-auto">

                          <div className="vs-cart-coupon">

                            <button
                              type="button"
                              className="vs-btn"
                            >
                              Update Cart
                            </button>

                            <Link
                              to="/shop"
                              className="vs-btn"
                            >
                              Continue Shopping
                            </Link>

                          </div>

                        </div>

                      </div>

                    </td>

                  </tr>

                </tbody>

              </table>

            </form>

            {/* Cart Totals */}
            <div className="row justify-content-end">

              <div className="col-md-8 col-lg-7 col-xl-6">

                <h2 className="h4 summary-title">
                  Cart Totals
                </h2>

                <table className="cart_totals">

                  <tbody>

                    {/* Subtotal */}
                    <tr>

                      <td>Cart Subtotal</td>

                      <td data-title="Cart Subtotal">
                        <span className="amount">
                          <bdi>
                            <span>₹</span>
                            {subtotal.toFixed(2)}
                          </bdi>
                        </span>
                      </td>

                    </tr>

                    {/* Shipping */}
                    <tr className="shipping">

                      <th>Shipping and Handling</th>

                      <td data-title="Shipping and Handling">

                        <ul className="woocommerce-shipping-methods list-unstyled">

                          <li>
                            <input
                              type="radio"
                              id="free_shipping"
                              name="shipping_method"
                              className="shipping_method"
                            />

                            <label htmlFor="free_shipping">
                              Free shipping
                            </label>
                          </li>

                          <li>
                            <input
                              type="radio"
                              id="flat_rate"
                              name="shipping_method"
                              className="shipping_method"
                              defaultChecked
                            />

                            <label htmlFor="flat_rate">
                              Flat rate
                            </label>
                          </li>

                        </ul>

                        <p className="woocommerce-shipping-destination">
                          Shipping options will be updated during checkout.
                        </p>
        <div>

      {/* Change Address Text */}
 <button
  type="button"
  onClick={() => setOpenForm(!openForm)}
  className="change-address-btn"
>
  Change Address
</button>

      {/* Form Open on Click */}
      {openForm && (
        <div className="shipping-calculator-form mt-3">

          <div className="mb-3">
            <select className="form-select">
              <option>Argentina</option>
              <option>Armenia</option>
              <option>Bangladesh</option>
            </select>
          </div>

          <div className="mb-3">
            <select className="form-select">
              <option>Select an option…</option>
              <option>Bagerhat</option>
              <option>Bandarban</option>
              <option>Barguna</option>
              <option>Barishal</option>
            </select>
          </div>

          <div className="mb-3">
            <input
              type="text"
              className="form-control"
              placeholder="Town / City"
            />
          </div>

          <div className="mb-3">
            <input
              type="text"
              className="form-control"
              placeholder="Postcode / ZIP"
            />
          </div>

          <button className="vs-btn">
            Update
          </button>

        </div>
      )}

    </div>
                      </td>

                    </tr>

                  </tbody>

                  {/* Total */}
                  <tfoot>

                    <tr className="order-total">

                      <td>Order Total</td>

                      <td data-title="Total">

                        <strong>
                          <span className="amount">
                            <bdi>
                              <span>₹</span>
                              {total.toFixed(2)}
                            </bdi>
                          </span>
                        </strong>

                      </td>

                    </tr>

                  </tfoot>

                </table>

                {/* Checkout */}
                <div className="wc-proceed-to-checkout mb-30">

                  <Link
                    to="/checkout"
                    className="vs-btn"
                  >
                    Proceed to Checkout
                  </Link>

                </div>

              </div>

            </div>

          </div>

        </section>

        <Footer />

      </main>

      <ScrollToTop />
    </>
  );
};

export default Cart;